import type {StyleObject} from '@pinecast/styletron-react';
import {useStyletron} from '@pinecast/styletron-react';
import * as React from 'react';

import {lintContent} from './lint';
import prepareStyle from './prepareStyle';
import type {CSS} from './types';

declare let Rollbar: any;

let lintCache: WeakSet<CSS>;
if (process.env.NODE_ENV !== 'production') {
  lintCache = new WeakSet<CSS>();
}

export const useCSS = () => {
  const [css] = useStyletron();

  return React.useCallback(
    (style: CSS, className?: string) => {
      // Linting
      if (process.env.NODE_ENV !== 'production') {
        if (!lintCache.has(style)) {
          lintContent(style);
          lintCache.add(style);
        }
      }

      let output = '';
      try {
        // Styletron emits numbers verbatim, so unitless lengths like
        // `{fontSize: 16}` would produce invalid `font-size:16`. prepareStyle
        // applies units (and the browser compatibility fixes) for every caller,
        // not just the ones coming through styled().
        prepareStyle(style);
        output = css(style as StyleObject);
      } catch (e) {
        Rollbar.error(`Could not render styles from CSS`, {error: e, style});
      }

      if (className) {
        if (output) {
          output += ' ';
        }
        output += className;
      }

      return output;
    },
    [css],
  );
};
